import type { FC } from "react";

import { NotFound as UINotFound } from "@jti/ui/components/NotFound/NotFound";

import type { inputs } from "./inputs.builder";

export type NotFoundProps = BuilderComponentProps<typeof inputs>;

export const NotFound: FC<NotFoundProps> = ({ title, subtitle, callToAction, backgroundImage }) => {
  return <UINotFound title={title} subtitle={subtitle} backgroundImageUrl={backgroundImage} cta={callToAction} />;
};
